// Text style presets for affiliate app blog elements
const textStylePresets = {
  heading1: {
    fontFamily: "'Proxima Nova',Helvetica,Arial,sans-serif",
    fontSize: '34px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '0px',
    color: '#101022',
    textAlign: 'left',
  },
  heading2: {
    fontFamily: "'Playfair Display Bold', Georgia, 'Times New Roman', serif",
    fontSize: '32px',
    fontWeight: 700,
    lineHeight: '1.2',
    letterSpacing: '-0.02em',
    color: '#101022',
    textAlign: 'left',
  },
  subheading1: {
    fontFamily: "'Proxima Nova',Helvetica,Arial,sans-serif",
    fontSize: '22px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '0px',
    color: '#101022',
    textAlign: 'left',
  },
  subheading2: {
    fontFamily: "'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: '22px',
    fontWeight: 600,
    lineHeight: '1.4',
    letterSpacing: '0.01em',
    color: '#101022',
    textAlign: 'left',
    textTransform: 'uppercase',
  },
  paragraph1: {
    fontFamily: "'Proxima Nova',Helvetica,Arial,sans-serif",
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '1.6',
    letterSpacing: '0.01em',
    color: '#101022',
    textAlign: 'left',
  },

};

// Frame presets for images and videos
const framePresets = {
  square: {
    borderRadius: '0px',
    boxShadow: 'none',
    border: 'none',
    aspectRatio: '1/1',
    objectFit: 'cover',
    width: '100%',
    height: 'auto',
  },
  landscape: {
    borderRadius: '0px',
    boxShadow: 'none',
    border: 'none',
    aspectRatio: '16/9',
    objectFit: 'cover',
    width: '100%',
    height: 'auto',
  },
  portrait: {
    borderRadius: '0px',
    boxShadow: 'none',
    border: 'none',
    aspectRatio: '9/16',
    objectFit: 'cover',
    width: '100%',
    height: 'auto',
  },
  portrait45: {
    borderRadius: '0px',
    boxShadow: 'none',
    border: 'none',
    aspectRatio: '4/5',
    objectFit: 'cover',
    width: '100%',
    height: 'auto',
  },
};

// Helper functions
export const getPresetNames = () => Object.keys(textStylePresets);
export const getPreset = (presetName) => textStylePresets[presetName] || textStylePresets.paragraph1;
export const getFramePresetNames = () => Object.keys(framePresets);
export const getFramePreset = (presetName) => framePresets[presetName] || framePresets.square;
export const getPresetFontFamilies = () => {
  const fontFamilies = new Set();
  Object.values(textStylePresets).forEach(preset => {
    if (preset.fontFamily) {
      fontFamilies.add(preset.fontFamily);
    }
  });
  return Array.from(fontFamilies).sort();
};

export default textStylePresets;
